<template>
  <article class="trainers">
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg5 class="head_contain">
            <p class="table_card__head--title">
              Entrenadores
            </p>
          </v-flex>
          <v-flex xs12 lg7 class="filter_options">
            <v-flex class="right mr-20">
              <button
                class="faccess_button"
                @click="$router.push({name: 'classes_trainer'})"
              >
                Crear nuevo entrenador
              </button>
            </v-flex>
            <div
              class="buttom_reload"
              @click="findTrainers()"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__info pr-0">
        <section class="trainers__container">
          <section
            class="data_card"
            v-for="location in locations"
            :key="location.id">
            <div
              class="data_card__image"
              :style="{backgroundImage: 'url('+ getImageServer() + location.attributes.image.url +')'}"></div>
            <div class="data_card__buttons">
              <div class="data_card__buttons--container">
                <div
                  class="data_card__buttons--qr"
                  @click="selectLocation(location)">
                  <qr-icon></qr-icon>
                </div>
                <div
                  class="data_card__buttons--edit"
                  @click="$router.push({name: 'trainer_edit', params: {id: location.id}})">
                  <v-icon>create</v-icon>
                </div>
              </div>
            </div>
            <div class="data_card__info">
              <p class="data_card__info--title">
                {{location.attributes.title}}
              </p>
              <div class="data_card__info--container">
                <span class="data_card__info--label">Descripción</span>
                <p class="data_card__info--text">
                  {{location.attributes.description}}
                </p>
              </div>
              <div class="data_card__info--container">
                <span class="data_card__info--label">Dirección</span>
                <p class="data_card__info--text">
                  {{location.attributes.address}}
                </p>
              </div>
              <div class="data_card__info--container">
                <span class="data_card__info--label">Correo electrónico</span>
                <p class="data_card__info--text">
                  {{location.attributes.email}}
                </p>
              </div>
            </div>
          </section>
        </section>
      </div>
    </div>
    
    <qr-modal
      v-if="show_qr_modal"
      :qr_text="location_selected"
      :location_name="location_name"
      @closeQrModal="resetQrModal()"></qr-modal>
    <div v-if="locations.length>0 && pages > 1" class="accessIndex__pagination">
      <v-pagination
        color="light-blue darken-3"
        v-model="pagination.page"
        :length="pages"></v-pagination>
      <label class="accessIndex__pagination--general_text">{{'de '+invitations_size}}</label>
      <label
        class="accessIndex__pagination--current_text"
        v-if="(pagination.page*pagination.rowsPerPage<invitations_size)">
        {{1+pagination.rowsPerPage*(pagination.page-1)+' - '+pagination.page*pagination.rowsPerPage}}
      </label>
      <label
        class="accessIndex__pagination--current_text"
        v-else>{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+invitations_size+' '}}</label>
    </div>
  </article>
</template>

<script>
export default {
  data(){
    return{
      locations:[],
      location_selected: null,
      show_qr_modal: false,
      location_name: '',
      pages:2,
      pagination: {page:1,rowsPerPage:15},
      invitations_size:10
    }
  },
  watch: {
   'pagination.page': function (val, oldVal) {
      if(oldVal!=val&&val!=null&&oldVal!=null){
        this.findTrainers();
      }
    }
  },
  methods:{
    selectLocation(object){
      this.location_selected = object.id;
      this.location_name = object.attributes.name
      this.show_qr_modal = true;
    },
    resetQrModal(){
      this.show_qr_modal = false;
      this.location_selected = null;
    },
    findTrainers(){
      try {
        this.$http.get('classes/index_trainers',
        {
          params:{
            page:this.pagination.page
          },
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}
        }).then(function(response){
          this.locations = response.body.data;
          this.invitations_size=response.body.meta.total_elements;
          this.pages=response.body.meta.pages;
          // cl locations
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined &&
               response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined &&
               response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    deleteLocation(id){
      try {
        this.$http.delete('locations/'+id,
        {headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}
        }).then(function(response){
          for (var i = 0; i < this.locations.length; i++) {
            if(this.locations[i].id == id){
              this.locations.splice(i, 1)
            }
          }

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined &&
               response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined &&
               response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },

  },
  mounted(){
    this.findTrainers();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/classes/Index_trainers.vue